// Images
import collegeMomDad from "./../images/collegeMomDad.jpg";
import baler from "./../images/baler.jpg";
import cargillMinne from "./../images/cargillMinne.jpg";
import cargillChampaign from "./../images/cargillChampaign.jpg";
import uline from "./../images/uline.jpg"
import gradMomDad from "./../images/gradMomDad.jpg";
import { uiucTheme, jdTheme, cargillTheme, ulineTheme } from "./../../../styles/theme";

export const timelineData = [
  {
    id: "uline",
    date: "June 2025",
    image: uline,
    alt: "Uline Job",
    text: "Began a full-time role as an Associate Software Developer at Uline in Waukegan, Illinois.",
    link: "/internshipPage",
    theme: ulineTheme,
  },
  {
    id: "grad",
    date: "May 2025",
    image: gradMomDad,
    alt: "Graduation",
    text: "Graduated with a Bachelor's of Science in Computer Science from UIUC.",
    link: "/UIUCPage",
    theme: uiucTheme,
  },
  {
    id: "cargill2",
    date: "May 2024",
    image: cargillMinne,
    alt: "Cargill MN",
    text: "Began full-time summer internship with Cargill at their Minnesota Headquarters.",
    link: "/internshipPage",
    theme: cargillTheme,
  },
  {
    id: "cargill1",
    date: "January 2023",
    image: cargillChampaign,
    alt: "Cargill Internship",
    text: "Started first part-time internship at Cargill's Digital Innovation Lab in Research Park.",
    link: "/internshipPage",
    theme: cargillTheme,
  },
  {
    id: "uiuc",
    date: "August 2021",
    image: collegeMomDad,
    alt: "Mom, Dad, and I at UIUC",
    text: "Began Computer Science degree at the University of Illinois Urbana-Champaign.",
    link: "/UIUCPage",
    theme: uiucTheme,
  },
  {
    id: "baler",
    date: "January 2017",
    image: baler,
    alt: "Our Baler",
    text: "Founded Daly Custom Baling with my brother, Danny, as a freshman in high school.",
    link: "/about",
    theme: jdTheme,
  },
];